// AUTO-GENERATED by scripts/recatalog-icons.mjs — do not edit by hand.
import type { ComponentType, SVGProps } from 'react';
import AnalyticsSvg from '@/assets/icons/analytics.svg';
import ArrowDownSvg from '@/assets/icons/arrow-down.svg';
import ArrowLeftSvg from '@/assets/icons/arrow-left.svg';
import ArrowRightSvg from '@/assets/icons/arrow-right.svg';
import ArrowUpSvg from '@/assets/icons/arrow-up.svg';
import AbTestFilledSvg from '@/assets/icons/behavior/ab-test-filled.svg';
import AbTestOutlineSvg from '@/assets/icons/behavior/ab-test-outline.svg';
import ActivityPulseFilledSvg from '@/assets/icons/behavior/activity-pulse-filled.svg';
import ActivityPulseOutlineSvg from '@/assets/icons/behavior/activity-pulse-outline.svg';
import AlertCircleFilledSvg from '@/assets/icons/behavior/alert-circle-filled.svg';
import AlertCircleOutlineSvg from '@/assets/icons/behavior/alert-circle-outline.svg';
import BarChartFilledSvg from '@/assets/icons/behavior/bar-chart-filled.svg';
import BarChartOutlineSvg from '@/assets/icons/behavior/bar-chart-outline.svg';
import BellFilledSvg from '@/assets/icons/behavior/bell-filled.svg';
import BellOutlineSvg from '@/assets/icons/behavior/bell-outline.svg';
import BlobFilledSvg from '@/assets/icons/behavior/blob-filled.svg';
import BlobOutlineSvg from '@/assets/icons/behavior/blob-outline.svg';
import BoneFilledSvg from '@/assets/icons/behavior/bone-filled.svg';
import BoneOutlineSvg from '@/assets/icons/behavior/bone-outline.svg';
import BookFilledSvg from '@/assets/icons/behavior/book-filled.svg';
import BookOutlineSvg from '@/assets/icons/behavior/book-outline.svg';
import BriefcaseFilledSvg from '@/assets/icons/behavior/briefcase-filled.svg';
import BuildingFilledSvg from '@/assets/icons/behavior/building-filled.svg';
import BuildingOutlineSvg from '@/assets/icons/behavior/building-outline.svg';
import CalendarFilledSvg from '@/assets/icons/behavior/calendar-filled.svg';
import CalendarOutlineSvg from '@/assets/icons/behavior/calendar-outline.svg';
import CatFilledSvg from '@/assets/icons/behavior/cat-filled.svg';
import CatOutlineSvg from '@/assets/icons/behavior/cat-outline.svg';
import ChatMessageFilledSvg from '@/assets/icons/behavior/chat-message-filled.svg';
import ChatMessageOutlineSvg from '@/assets/icons/behavior/chat-message-outline.svg';
import CheckCircleFilledSvg from '@/assets/icons/behavior/check-circle-filled.svg';
import CheckCircleOutlineSvg from '@/assets/icons/behavior/check-circle-outline.svg';
import CheckEditFilledSvg from '@/assets/icons/behavior/check-edit-filled.svg';
import CheckEditOutlineSvg from '@/assets/icons/behavior/check-edit-outline.svg';
import CheckSquareFilledSvg from '@/assets/icons/behavior/check-square-filled.svg';
import CheckSquareOutlineSvg from '@/assets/icons/behavior/check-square-outline.svg';
import ChipsFilledSvg from '@/assets/icons/behavior/chips-filled.svg';
import ChipsOutlineSvg from '@/assets/icons/behavior/chips-outline.svg';
import ClipboardSearchFilledSvg from '@/assets/icons/behavior/clipboard-search-filled.svg';
import ClipboardSearchOutlineSvg from '@/assets/icons/behavior/clipboard-search-outline.svg';
import CloseCircleFilledSvg from '@/assets/icons/behavior/close-circle-filled.svg';
import CloseCircleOutlineSvg from '@/assets/icons/behavior/close-circle-outline.svg';
import CloudCheckFilledSvg from '@/assets/icons/behavior/cloud-check-filled.svg';
import CloudCheckOutlineSvg from '@/assets/icons/behavior/cloud-check-outline.svg';
import CloudUploadFilledSvg from '@/assets/icons/behavior/cloud-upload-filled.svg';
import CloudUploadOutlineSvg from '@/assets/icons/behavior/cloud-upload-outline.svg';
import CreditCardFilledSvg from '@/assets/icons/behavior/credit-card-filled.svg';
import CreditCardOutlineSvg from '@/assets/icons/behavior/credit-card-outline.svg';
import CrownFilledSvg from '@/assets/icons/behavior/crown-filled.svg';
import CrownOutlineSvg from '@/assets/icons/behavior/crown-outline.svg';
import CurrencySyncFilledSvg from '@/assets/icons/behavior/currency-sync-filled.svg';
import CurrencySyncOutlineSvg from '@/assets/icons/behavior/currency-sync-outline.svg';
import DashboardGridFilledSvg from '@/assets/icons/behavior/dashboard-grid-filled.svg';
import DashboardGridOutlineSvg from '@/assets/icons/behavior/dashboard-grid-outline.svg';
import DogFilledSvg from '@/assets/icons/behavior/dog-filled.svg';
import DogOutlineSvg from '@/assets/icons/behavior/dog-outline.svg';
import DoorEnterFilledSvg from '@/assets/icons/behavior/door-enter-filled.svg';
import DoorEnterOutlineSvg from '@/assets/icons/behavior/door-enter-outline.svg';
import DoorExitFilledSvg from '@/assets/icons/behavior/door-exit-filled.svg';
import DoorExitOutlineSvg from '@/assets/icons/behavior/door-exit-outline.svg';
import EditPencilFilledSvg from '@/assets/icons/behavior/edit-pencil-filled.svg';
import EditPencilOutlineSvg from '@/assets/icons/behavior/edit-pencil-outline.svg';
import ExternalLinkFilledSvg from '@/assets/icons/behavior/external-link-filled.svg';
import ExternalLinkOutlineSvg from '@/assets/icons/behavior/external-link-outline.svg';
import EyeFilledSvg from '@/assets/icons/behavior/eye-filled.svg';
import EyeOffFilledSvg from '@/assets/icons/behavior/eye-off-filled.svg';
import EyeOffOutlineSvg from '@/assets/icons/behavior/eye-off-outline.svg';
import EyeOutlineSvg from '@/assets/icons/behavior/eye-outline.svg';
import FileShieldFilledSvg from '@/assets/icons/behavior/file-shield-filled.svg';
import FileShieldOutlineSvg from '@/assets/icons/behavior/file-shield-outline.svg';
import FileTextFilledSvg from '@/assets/icons/behavior/file-text-filled.svg';
import FileTextOutlineSvg from '@/assets/icons/behavior/file-text-outline.svg';
import FilterFilledSvg from '@/assets/icons/behavior/filter-filled.svg';
import FilterOutlineSvg from '@/assets/icons/behavior/filter-outline.svg';
import GlobeCursorFilledSvg from '@/assets/icons/behavior/globe-cursor-filled.svg';
import GlobeCursorOutlineSvg from '@/assets/icons/behavior/globe-cursor-outline.svg';
import GraduationCapFilledSvg from '@/assets/icons/behavior/graduation-cap-filled.svg';
import GraduationCapOutlineSvg from '@/assets/icons/behavior/graduation-cap-outline.svg';
import HeartFilledSvg from '@/assets/icons/behavior/heart-filled.svg';
import HeartOutlineSvg from '@/assets/icons/behavior/heart-outline.svg';
import HelpSquareFilledSvg from '@/assets/icons/behavior/help-square-filled.svg';
import HelpSquareOutlineSvg from '@/assets/icons/behavior/help-square-outline.svg';
import HomeHeartFilledSvg from '@/assets/icons/behavior/home-heart-filled.svg';
import HomeHeartOutlineSvg from '@/assets/icons/behavior/home-heart-outline.svg';
import IdCardFilledSvg from '@/assets/icons/behavior/id-card-filled.svg';
import IdCardOutlineSvg from '@/assets/icons/behavior/id-card-outline.svg';
import InfoCircleFilledSvg from '@/assets/icons/behavior/info-circle-filled.svg';
import InfoCircleOutlineSvg from '@/assets/icons/behavior/info-circle-outline.svg';
import LightbulbFilledSvg from '@/assets/icons/behavior/lightbulb-filled.svg';
import LightbulbIdeaFilledSvg from '@/assets/icons/behavior/lightbulb-idea-filled.svg';
import LightbulbIdeaOutlineSvg from '@/assets/icons/behavior/lightbulb-idea-outline.svg';
import LightbulbOutlineSvg from '@/assets/icons/behavior/lightbulb-outline.svg';
import LogInFilledSvg from '@/assets/icons/behavior/log-in-filled.svg';
import LogInOutlineSvg from '@/assets/icons/behavior/log-in-outline.svg';
import LogOutFilledSvg from '@/assets/icons/behavior/log-out-filled.svg';
import LogOutOutlineSvg from '@/assets/icons/behavior/log-out-outline.svg';
import MailFilledSvg from '@/assets/icons/behavior/mail-filled.svg';
import MailMutedFilledSvg from '@/assets/icons/behavior/mail-muted-filled.svg';
import MailMutedOutlineSvg from '@/assets/icons/behavior/mail-muted-outline.svg';
import MailOutlineSvg from '@/assets/icons/behavior/mail-outline.svg';
import MailPlusFilledSvg from '@/assets/icons/behavior/mail-plus-filled.svg';
import MailPlusOutlineSvg from '@/assets/icons/behavior/mail-plus-outline.svg';
import MinusCircleFilledSvg from '@/assets/icons/behavior/minus-circle-filled.svg';
import MinusCircleOutlineSvg from '@/assets/icons/behavior/minus-circle-outline.svg';
import MinusSquareFilledSvg from '@/assets/icons/behavior/minus-square-filled.svg';
import MinusSquareOutlineSvg from '@/assets/icons/behavior/minus-square-outline.svg';
import PaintRollerFilledSvg from '@/assets/icons/behavior/paint-roller-filled.svg';
import PaintRollerOutlineSvg from '@/assets/icons/behavior/paint-roller-outline.svg';
import PawPrintFilledSvg from '@/assets/icons/behavior/paw-print-filled.svg';
import PawPrintOutlineSvg from '@/assets/icons/behavior/paw-print-outline.svg';
import PersonWalkingFilledSvg from '@/assets/icons/behavior/person-walking-filled.svg';
import PersonWalkingOutlineSvg from '@/assets/icons/behavior/person-walking-outline.svg';
import PlayCircleOutlineSvg from '@/assets/icons/behavior/play-circle-outline.svg';
import PlayFilledSvg from '@/assets/icons/behavior/play-filled.svg';
import PlayOutlineSvg from '@/assets/icons/behavior/play-outline.svg';
import PuzzlePieceFilledSvg from '@/assets/icons/behavior/puzzle-piece-filled.svg';
import PuzzlePieceOutlineSvg from '@/assets/icons/behavior/puzzle-piece-outline.svg';
import RobotFilledSvg from '@/assets/icons/behavior/robot-filled.svg';
import RobotOutlineSvg from '@/assets/icons/behavior/robot-outline.svg';
import RunningFilledSvg from '@/assets/icons/behavior/running-filled.svg';
import RunningOutlineSvg from '@/assets/icons/behavior/running-outline.svg';
import ScalesBalanceFilledSvg from '@/assets/icons/behavior/scales-balance-filled.svg';
import ScalesBalanceOutlineSvg from '@/assets/icons/behavior/scales-balance-outline.svg';
import SearchFilledSvg from '@/assets/icons/behavior/search-filled.svg';
import SearchOutlineSvg from '@/assets/icons/behavior/search-outline.svg';
import SettingsGearFilledSvg from '@/assets/icons/behavior/settings-gear-filled.svg';
import SettingsGearOutlineSvg from '@/assets/icons/behavior/settings-gear-outline.svg';
import ShareFilledSvg from '@/assets/icons/behavior/share-filled.svg';
import ShareOutlineSvg from '@/assets/icons/behavior/share-outline.svg';
import ShieldFilledSvg from '@/assets/icons/behavior/shield-filled.svg';
import ShieldOutlineSvg from '@/assets/icons/behavior/shield-outline.svg';
import ShoppingCartFilledSvg from '@/assets/icons/behavior/shopping-cart-filled.svg';
import ShoppingCartOutlineSvg from '@/assets/icons/behavior/shopping-cart-outline.svg';
import SlidersFilledSvg from '@/assets/icons/behavior/sliders-filled.svg';
import SlidersOutlineSvg from '@/assets/icons/behavior/sliders-outline.svg';
import SquareFilledSvg from '@/assets/icons/behavior/square-filled.svg';
import SquareOutlineSvg from '@/assets/icons/behavior/square-outline.svg';
import StarSparkleFilledSvg from '@/assets/icons/behavior/star-sparkle-filled.svg';
import StarSparkleOutlineSvg from '@/assets/icons/behavior/star-sparkle-outline.svg';
import SwapFilledSvg from '@/assets/icons/behavior/swap-filled.svg';
import SwapOutlineSvg from '@/assets/icons/behavior/swap-outline.svg';
import TrashFilledSvg from '@/assets/icons/behavior/trash-filled.svg';
import TrashOutlineSvg from '@/assets/icons/behavior/trash-outline.svg';
import UserCircleFilledSvg from '@/assets/icons/behavior/user-circle-filled.svg';
import UserCircleOutlineSvg from '@/assets/icons/behavior/user-circle-outline.svg';
import UserFilledSvg from '@/assets/icons/behavior/user-filled.svg';
import UserLockFilledSvg from '@/assets/icons/behavior/user-lock-filled.svg';
import UserLockOutlineSvg from '@/assets/icons/behavior/user-lock-outline.svg';
import UserOutlineSvg from '@/assets/icons/behavior/user-outline.svg';
import UserRemoveFilledSvg from '@/assets/icons/behavior/user-remove-filled.svg';
import UserRemoveOutlineSvg from '@/assets/icons/behavior/user-remove-outline.svg';
import UserSettingsFilledSvg from '@/assets/icons/behavior/user-settings-filled.svg';
import UserSettingsOutlineSvg from '@/assets/icons/behavior/user-settings-outline.svg';
import UsersPairFilledSvg from '@/assets/icons/behavior/users-pair-filled.svg';
import UsersPairOutlineSvg from '@/assets/icons/behavior/users-pair-outline.svg';
import WarningTriangleFilledSvg from '@/assets/icons/behavior/warning-triangle-filled.svg';
import WarningTriangleOutlineSvg from '@/assets/icons/behavior/warning-triangle-outline.svg';
import BoldSvg from '@/assets/icons/bold.svg';
import CaretDownSvg from '@/assets/icons/caret-down.svg';
import CaretLeftSvg from '@/assets/icons/caret-left.svg';
import CaretRightSvg from '@/assets/icons/caret-right.svg';
import CaretUpSvg from '@/assets/icons/caret-up.svg';
import ChartSvg from '@/assets/icons/chart.svg';
import CheckSvg from '@/assets/icons/check.svg';
import ChevronDownSvg from '@/assets/icons/chevron-down.svg';
import ChevronLeftSvg from '@/assets/icons/chevron-left.svg';
import ChevronRightSvg from '@/assets/icons/chevron-right.svg';
import ChevronUpSvg from '@/assets/icons/chevron-up.svg';
import ClipSvg from '@/assets/icons/clip.svg';
import ClockSvg from '@/assets/icons/clock.svg';
import CloseSvg from '@/assets/icons/close.svg';
import CompareSvg from '@/assets/icons/compare.svg';
import DocsAndCreditsSvg from '@/assets/icons/docs-and-credits.svg';
import DotSvg from '@/assets/icons/dot.svg';
import DownloadSvg from '@/assets/icons/download.svg';
import FacebookSvg from '@/assets/icons/facebook.svg';
import HistorySvg from '@/assets/icons/history.svg';
import InstagramSvg from '@/assets/icons/instagram.svg';
import ItalicSvg from '@/assets/icons/italic.svg';
import LinkSvg from '@/assets/icons/link.svg';
import ListSvg from '@/assets/icons/list.svg';
import LogInSvg from '@/assets/icons/log-in.svg';
import LogOutSvg from '@/assets/icons/log-out.svg';
import MenuBurgerSvg from '@/assets/icons/menu-burger.svg';
import MinusSvg from '@/assets/icons/minus.svg';
import MoreOptionsSvg from '@/assets/icons/more-options.svg';
import PaypalSvg from '@/assets/icons/paypal.svg';
import PlusSvg from '@/assets/icons/plus.svg';
import StatusMixedSvg from '@/assets/icons/quiz/status-mixed.svg';
import RadioOffSvg from '@/assets/icons/radio-off.svg';
import RadioOnSvg from '@/assets/icons/radio-on.svg';
import TiktokSvg from '@/assets/icons/tiktok.svg';
import TrendDownSvg from '@/assets/icons/trend-down.svg';
import TrendUpSvg from '@/assets/icons/trend-up.svg';
import UndoSvg from '@/assets/icons/undo.svg';
import UploadSvg from '@/assets/icons/upload.svg';

export type SvgIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export const icons = {
  'analytics': AnalyticsSvg,
  'arrow-down': ArrowDownSvg,
  'arrow-left': ArrowLeftSvg,
  'arrow-right': ArrowRightSvg,
  'arrow-up': ArrowUpSvg,
  'ab-test-filled': AbTestFilledSvg,
  'ab-test-outline': AbTestOutlineSvg,
  'activity-pulse-filled': ActivityPulseFilledSvg,
  'activity-pulse-outline': ActivityPulseOutlineSvg,
  'alert-circle-filled': AlertCircleFilledSvg,
  'alert-circle-outline': AlertCircleOutlineSvg,
  'bar-chart-filled': BarChartFilledSvg,
  'bar-chart-outline': BarChartOutlineSvg,
  'bell-filled': BellFilledSvg,
  'bell-outline': BellOutlineSvg,
  'blob-filled': BlobFilledSvg,
  'blob-outline': BlobOutlineSvg,
  'bone-filled': BoneFilledSvg,
  'bone-outline': BoneOutlineSvg,
  'book-filled': BookFilledSvg,
  'book-outline': BookOutlineSvg,
  'briefcase-filled': BriefcaseFilledSvg,
  'building-filled': BuildingFilledSvg,
  'building-outline': BuildingOutlineSvg,
  'calendar-filled': CalendarFilledSvg,
  'calendar-outline': CalendarOutlineSvg,
  'cat-filled': CatFilledSvg,
  'cat-outline': CatOutlineSvg,
  'chat-message-filled': ChatMessageFilledSvg,
  'chat-message-outline': ChatMessageOutlineSvg,
  'check-circle-filled': CheckCircleFilledSvg,
  'check-circle-outline': CheckCircleOutlineSvg,
  'check-edit-filled': CheckEditFilledSvg,
  'check-edit-outline': CheckEditOutlineSvg,
  'check-square-filled': CheckSquareFilledSvg,
  'check-square-outline': CheckSquareOutlineSvg,
  'chips-filled': ChipsFilledSvg,
  'chips-outline': ChipsOutlineSvg,
  'clipboard-search-filled': ClipboardSearchFilledSvg,
  'clipboard-search-outline': ClipboardSearchOutlineSvg,
  'close-circle-filled': CloseCircleFilledSvg,
  'close-circle-outline': CloseCircleOutlineSvg,
  'cloud-check-filled': CloudCheckFilledSvg,
  'cloud-check-outline': CloudCheckOutlineSvg,
  'cloud-upload-filled': CloudUploadFilledSvg,
  'cloud-upload-outline': CloudUploadOutlineSvg,
  'credit-card-filled': CreditCardFilledSvg,
  'credit-card-outline': CreditCardOutlineSvg,
  'crown-filled': CrownFilledSvg,
  'crown-outline': CrownOutlineSvg,
  'currency-sync-filled': CurrencySyncFilledSvg,
  'currency-sync-outline': CurrencySyncOutlineSvg,
  'dashboard-grid-filled': DashboardGridFilledSvg,
  'dashboard-grid-outline': DashboardGridOutlineSvg,
  'dog-filled': DogFilledSvg,
  'dog-outline': DogOutlineSvg,
  'door-enter-filled': DoorEnterFilledSvg,
  'door-enter-outline': DoorEnterOutlineSvg,
  'door-exit-filled': DoorExitFilledSvg,
  'door-exit-outline': DoorExitOutlineSvg,
  'edit-pencil-filled': EditPencilFilledSvg,
  'edit-pencil-outline': EditPencilOutlineSvg,
  'external-link-filled': ExternalLinkFilledSvg,
  'external-link-outline': ExternalLinkOutlineSvg,
  'eye-filled': EyeFilledSvg,
  'eye-off-filled': EyeOffFilledSvg,
  'eye-off-outline': EyeOffOutlineSvg,
  'eye-outline': EyeOutlineSvg,
  'file-shield-filled': FileShieldFilledSvg,
  'file-shield-outline': FileShieldOutlineSvg,
  'file-text-filled': FileTextFilledSvg,
  'file-text-outline': FileTextOutlineSvg,
  'filter-filled': FilterFilledSvg,
  'filter-outline': FilterOutlineSvg,
  'globe-cursor-filled': GlobeCursorFilledSvg,
  'globe-cursor-outline': GlobeCursorOutlineSvg,
  'graduation-cap-filled': GraduationCapFilledSvg,
  'graduation-cap-outline': GraduationCapOutlineSvg,
  'heart-filled': HeartFilledSvg,
  'heart-outline': HeartOutlineSvg,
  'help-square-filled': HelpSquareFilledSvg,
  'help-square-outline': HelpSquareOutlineSvg,
  'home-heart-filled': HomeHeartFilledSvg,
  'home-heart-outline': HomeHeartOutlineSvg,
  'id-card-filled': IdCardFilledSvg,
  'id-card-outline': IdCardOutlineSvg,
  'info-circle-filled': InfoCircleFilledSvg,
  'info-circle-outline': InfoCircleOutlineSvg,
  'lightbulb-filled': LightbulbFilledSvg,
  'lightbulb-idea-filled': LightbulbIdeaFilledSvg,
  'lightbulb-idea-outline': LightbulbIdeaOutlineSvg,
  'lightbulb-outline': LightbulbOutlineSvg,
  'log-in-filled': LogInFilledSvg,
  'log-in-outline': LogInOutlineSvg,
  'log-out-filled': LogOutFilledSvg,
  'log-out-outline': LogOutOutlineSvg,
  'mail-filled': MailFilledSvg,
  'mail-muted-filled': MailMutedFilledSvg,
  'mail-muted-outline': MailMutedOutlineSvg,
  'mail-outline': MailOutlineSvg,
  'mail-plus-filled': MailPlusFilledSvg,
  'mail-plus-outline': MailPlusOutlineSvg,
  'minus-circle-filled': MinusCircleFilledSvg,
  'minus-circle-outline': MinusCircleOutlineSvg,
  'minus-square-filled': MinusSquareFilledSvg,
  'minus-square-outline': MinusSquareOutlineSvg,
  'paint-roller-filled': PaintRollerFilledSvg,
  'paint-roller-outline': PaintRollerOutlineSvg,
  'paw-print-filled': PawPrintFilledSvg,
  'paw-print-outline': PawPrintOutlineSvg,
  'person-walking-filled': PersonWalkingFilledSvg,
  'person-walking-outline': PersonWalkingOutlineSvg,
  'play-circle-outline': PlayCircleOutlineSvg,
  'play-filled': PlayFilledSvg,
  'play-outline': PlayOutlineSvg,
  'puzzle-piece-filled': PuzzlePieceFilledSvg,
  'puzzle-piece-outline': PuzzlePieceOutlineSvg,
  'robot-filled': RobotFilledSvg,
  'robot-outline': RobotOutlineSvg,
  'running-filled': RunningFilledSvg,
  'running-outline': RunningOutlineSvg,
  'scales-balance-filled': ScalesBalanceFilledSvg,
  'scales-balance-outline': ScalesBalanceOutlineSvg,
  'search-filled': SearchFilledSvg,
  'search-outline': SearchOutlineSvg,
  'settings-gear-filled': SettingsGearFilledSvg,
  'settings-gear-outline': SettingsGearOutlineSvg,
  'share-filled': ShareFilledSvg,
  'share-outline': ShareOutlineSvg,
  'shield-filled': ShieldFilledSvg,
  'shield-outline': ShieldOutlineSvg,
  'shopping-cart-filled': ShoppingCartFilledSvg,
  'shopping-cart-outline': ShoppingCartOutlineSvg,
  'sliders-filled': SlidersFilledSvg,
  'sliders-outline': SlidersOutlineSvg,
  'square-filled': SquareFilledSvg,
  'square-outline': SquareOutlineSvg,
  'star-sparkle-filled': StarSparkleFilledSvg,
  'star-sparkle-outline': StarSparkleOutlineSvg,
  'swap-filled': SwapFilledSvg,
  'swap-outline': SwapOutlineSvg,
  'trash-filled': TrashFilledSvg,
  'trash-outline': TrashOutlineSvg,
  'user-circle-filled': UserCircleFilledSvg,
  'user-circle-outline': UserCircleOutlineSvg,
  'user-filled': UserFilledSvg,
  'user-lock-filled': UserLockFilledSvg,
  'user-lock-outline': UserLockOutlineSvg,
  'user-outline': UserOutlineSvg,
  'user-remove-filled': UserRemoveFilledSvg,
  'user-remove-outline': UserRemoveOutlineSvg,
  'user-settings-filled': UserSettingsFilledSvg,
  'user-settings-outline': UserSettingsOutlineSvg,
  'users-pair-filled': UsersPairFilledSvg,
  'users-pair-outline': UsersPairOutlineSvg,
  'warning-triangle-filled': WarningTriangleFilledSvg,
  'warning-triangle-outline': WarningTriangleOutlineSvg,
  'bold': BoldSvg,
  'caret-down': CaretDownSvg,
  'caret-left': CaretLeftSvg,
  'caret-right': CaretRightSvg,
  'caret-up': CaretUpSvg,
  'chart': ChartSvg,
  'check': CheckSvg,
  'chevron-down': ChevronDownSvg,
  'chevron-left': ChevronLeftSvg,
  'chevron-right': ChevronRightSvg,
  'chevron-up': ChevronUpSvg,
  'clip': ClipSvg,
  'clock': ClockSvg,
  'close': CloseSvg,
  'compare': CompareSvg,
  'docs-and-credits': DocsAndCreditsSvg,
  'dot': DotSvg,
  'download': DownloadSvg,
  'facebook': FacebookSvg,
  'history': HistorySvg,
  'instagram': InstagramSvg,
  'italic': ItalicSvg,
  'link': LinkSvg,
  'list': ListSvg,
  'log-in': LogInSvg,
  'log-out': LogOutSvg,
  'menu-burger': MenuBurgerSvg,
  'minus': MinusSvg,
  'more-options': MoreOptionsSvg,
  'paypal': PaypalSvg,
  'plus': PlusSvg,
  'status-mixed': StatusMixedSvg,
  'radio-off': RadioOffSvg,
  'radio-on': RadioOnSvg,
  'tiktok': TiktokSvg,
  'trend-down': TrendDownSvg,
  'trend-up': TrendUpSvg,
  'undo': UndoSvg,
  'upload': UploadSvg,
} as const satisfies Record<string, SvgIconComponent>;

export type IconName = keyof typeof icons;
